export default {
  // Common
  save: "Enregistrer",
  cancel: "Annuler",
  loading: "Chargement...",
  inactive: "Inactif",
  active: "Actif",
  edit: "Modifier",
  delete: "Supprimer",
  name: "Nom",
  email: "E-mail",
  description: "Description",
  date: "Date",
  time: "Heure",
  status: "Statut",
  notes: "Notes",
  close: "Fermer",
  language: "Langue",

  // Auth
  auth_welcome: "Bon retour",
  auth_create: "Créer un compte",
  auth_signin_sub: "Connectez-vous à votre tableau de bord",
  auth_create_sub: "Configurez votre système de réservation",
  auth_business_name: "Nom de l'entreprise",
  auth_business_placeholder: "Votre nom d'entreprise",
  auth_email_placeholder: "admin@entreprise.com",
  auth_password: "Mot de passe",
  auth_password_placeholder: "Entrez votre mot de passe",
  auth_signing_in: "Chargement...",
  auth_toggle_login: "Déjà un compte ? Se connecter",
  auth_toggle_register: "Pas de compte ? Créer un",
  auth_success_register: "Compte créé",
  auth_success_login: "Bon retour !",
  auth_error: "Échec de l'authentification",
  auth_email_invalid: "Veuillez entrer une adresse e-mail valide",
  auth_forgot_password: "Mot de passe oublié ?",
  auth_password_confirm: "Confirmer le mot de passe",
  auth_password_confirm_placeholder: "Ressaisissez votre mot de passe",
  auth_password_mismatch: "Les mots de passe ne correspondent pas",

  forgot_title: "Mot de passe oublié",
  forgot_sub: "Entrez votre adresse e-mail et nous vous enverrons un code de réinitialisation.",
  forgot_send: "Envoyer le code",
  forgot_sent_title: "Vérifiez votre e-mail",
  forgot_sent_sub: "Nous avons envoyé un code à 6 chiffres à votre adresse e-mail. Il expire dans 30 minutes.",
  forgot_enter_code: "Entrer le code",
  forgot_back_login: "Retour à la connexion",

  reset_title: "Réinitialiser le mot de passe",
  reset_sub: "Entrez le code à 6 chiffres de votre e-mail et choisissez un nouveau mot de passe.",
  reset_code_label: "Code de réinitialisation",
  reset_new_password: "Nouveau mot de passe",
  reset_password_placeholder: "Min. 4 caractères",
  reset_password_hint: "Minimum 4 caractères",
  reset_password_min: "Le mot de passe doit comporter au moins 4 caractères",
  reset_invalid_code: "Code invalide ou expiré",
  reset_submit: "Réinitialiser le mot de passe",
  reset_done_title: "Mot de passe mis à jour !",
  reset_done_sub: "Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.",

  // Sidebar
  nav_dashboard: "Tableau de bord",
  nav_services: "Services",
  nav_staff: "Personnel",
  nav_appointments: "Rendez-vous",
  nav_calendar: "Calendrier",
  nav_settings: "Paramètres",
  nav_widget: "Widget",
  nav_logout: "Se déconnecter",

  // Dashboard
  dashboard_title: "Tableau de bord",
  dashboard_loading: "Chargement du tableau de bord...",
  dashboard_today: "Aujourd'hui",
  dashboard_total: "Total des réservations",
  dashboard_pending: "En attente",
  dashboard_services: "Services",
  dashboard_todays_schedule: "Programme du jour",
  dashboard_upcoming: "À venir",
  dashboard_view_all: "Voir tout",
  dashboard_no_today: "Aucun rendez-vous aujourd'hui",
  dashboard_no_upcoming: "Aucun rendez-vous à venir",

  // Services
  services_title: "Services",
  services_add: "Ajouter un service",
  services_empty: "Aucun service pour l'instant",
  services_empty_sub: "Créez votre premier service pour commencer à accepter des réservations",
  services_new: "Nouveau service",
  services_edit: "Modifier le service",
  services_new_sub: "Créer un nouveau service réservable",
  services_edit_sub: "Mettre à jour les détails du service",
  services_name_placeholder: "ex. Coupe de cheveux",
  services_desc_placeholder: "Brève description",
  services_duration: "Durée",
  services_price: "Prix",
  services_buffer: "Temps tampon",
  services_color: "Couleur",
  services_name_required: "Le nom du service est obligatoire",
  services_created: "Service créé",
  services_updated: "Service mis à jour",
  services_deleted: "Service supprimé",
  services_load_error: "Erreur lors du chargement des services",
  services_save_error: "Erreur lors de l'enregistrement",
  services_delete_error: "Erreur lors de la suppression",
  services_delete_confirm_title: "Supprimer le service",
  services_delete_confirm_sub: "Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action est irréversible.",
  services_translations: "Traductions",
  services_trans_name_placeholder: "Nom du service dans cette langue",
  services_trans_desc_placeholder: "Description dans cette langue (optionnel)",

  // Staff
  staff_title: "Personnel",
  staff_add: "Ajouter du personnel",
  staff_empty: "Aucun membre du personnel pour l'instant",
  staff_empty_sub: "Ajoutez du personnel pour que les clients puissent choisir avec qui réserver",
  staff_new: "Ajouter du personnel",
  staff_edit: "Modifier le personnel",
  staff_new_sub: "Ajouter un nouveau membre de l'équipe",
  staff_edit_sub: "Mettre à jour les détails du personnel",
  staff_email_optional: "E-mail (optionnel)",
  staff_email_placeholder: "jean@exemple.com",
  staff_name_placeholder: "ex. Jean Dupont",
  staff_name_required: "Le nom est obligatoire",
  staff_created: "Personnel ajouté",
  staff_updated: "Personnel mis à jour",
  staff_deleted: "Personnel supprimé",
  staff_load_error: "Erreur lors du chargement du personnel",
  staff_save_error: "Erreur lors de l'enregistrement",
  staff_delete_error: "Erreur lors de la suppression",
  staff_delete_confirm_title: "Supprimer le membre du personnel",
  staff_delete_confirm_sub: "Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action est irréversible.",

  // Appointments
  appointments_title: "Rendez-vous",
  appointments_search: "Rechercher par nom, e-mail ou service...",
  appointments_filter_all: "Tous",
  appointments_filter_confirmed: "Confirmés",
  appointments_filter_pending: "En attente",
  appointments_filter_cancelled: "Annulés",
  appointments_none: "Aucun rendez-vous trouvé",
  appointments_customer: "Client",
  appointments_service: "Service",
  appointments_staff: "Personnel",
  appointments_edit: "Modifier",
  appointments_confirm: "Confirmer",
  appointments_cancel: "Annuler",
  appointments_delete: "Supprimer",
  appointments_edit_title: "Modifier le rendez-vous",
  appointments_edit_sub: "Mettre à jour les détails du rendez-vous",
  appointments_notes_placeholder: "Ajouter des notes...",
  appointments_status_updated: "Statut mis à jour : {{status}}",
  appointments_load_error: "Erreur lors du chargement",
  appointments_status_error: "Erreur lors de la mise à jour du statut",
  appointments_update_error: "Erreur lors de la mise à jour",
  appointments_delete_error: "Erreur lors de la suppression",
  appointments_updated: "Rendez-vous mis à jour",
  appointments_deleted: "Rendez-vous supprimé",

  // Calendar
  calendar_title: "Calendrier",
  calendar_today: "Aujourd'hui",
  calendar_reschedule_ok: "Reprogrammé",
  calendar_reschedule_err: "Erreur lors de la reprogrammation",
  calendar_load_error: "Erreur lors du chargement des rendez-vous",

  // Settings
  settings_title: "Paramètres",
  settings_save: "Enregistrer les modifications",
  settings_saving: "Enregistrement...",
  settings_business_info: "Informations sur l'entreprise",
  settings_business_name: "Nom de l'entreprise",
  settings_business_desc: "Description",
  settings_business_desc_placeholder: "Brève description de votre entreprise",
  settings_booking_url: "URL de réservation",
  settings_working_hours: "Heures de travail",
  settings_hours_to: "à",
  settings_widget_appearance: "Apparence du widget",
  settings_primary_color: "Couleur principale",
  settings_accent_color: "Couleur d'accentuation",
  settings_saved: "Paramètres enregistrés",
  settings_save_error: "Erreur lors de l'enregistrement",
  settings_load_error: "Erreur lors du chargement des paramètres",
  settings_link_copied: "Lien de réservation copié !",
  settings_approval_title: "Approbation des réservations",
  settings_approval_sub: "Confirmer automatiquement les réservations en attente si elles ne sont pas examinées dans le délai sélectionné.",
  settings_approval_off: "Désactivé — approbation manuelle uniquement",
  settings_approval_30m: "Après 30 minutes",
  settings_approval_1h: "Après 1 heure",
  settings_approval_2h: "Après 2 heures",
  settings_approval_6h: "Après 6 heures",
  settings_approval_12h: "Après 12 heures",
  settings_approval_active: "Les réservations sont confirmées automatiquement après {{hours}}h",
  settings_approval_inactive: "L'approbation automatique est désactivée",

  // Widget Preview
  widget_preview_title: "Widget de réservation",
  widget_preview_open: "Ouvrir le widget",
  widget_preview_loading: "Chargement du lien de réservation...",
  widget_preview_embed: "Code d'intégration",
  widget_preview_live: "Aperçu en direct",
  widget_preview_embed_hint: "Copiez et collez ce code dans votre site Web pour intégrer le widget.",
  widget_preview_copied: "Copié dans le presse-papiers",

  // Booking Widget
  booking_book_appointment: "Prendre un rendez-vous",
  booking_not_found: "Entreprise introuvable.",
  booking_not_found_sub: "Veuillez vérifier le lien de réservation et réessayer.",
  booking_step_service: "Service",
  booking_step_staff: "Personnel",
  booking_step_datetime: "Date et heure",
  booking_step_details: "Détails",
  booking_choose_service: "Choisissez un service",
  booking_no_services: "Aucun service disponible",
  booking_choose_staff: "Choisissez un membre du personnel",
  booking_any_staff: "N'importe lequel de disponible",
  booking_any_staff_sub: "Nous attribuerons le premier membre disponible",
  booking_pick_datetime: "Choisissez la date et l'heure",
  booking_available_times: "Horaires disponibles pour {{date}}",
  booking_no_slots: "Aucun créneau disponible pour cette date",
  booking_continue: "Continuer",
  booking_your_details: "Vos coordonnées",
  booking_name: "Nom *",
  booking_email: "E-mail *",
  booking_phone: "Téléphone",
  booking_name_placeholder: "Votre nom complet",
  booking_email_placeholder: "votre@email.com",
  booking_phone_placeholder: "Numéro de téléphone",
  booking_confirm: "Confirmer la réservation",
  booking_confirming: "Réservation...",
  booking_pending_title: "Demande reçue !",
  booking_pending_sub: "Nous vous enverrons un e-mail dès que votre rendez-vous sera confirmé.",
  booking_success_title: "Réservation confirmée !",
  booking_success_sub: "Votre rendez-vous a été planifié",
  booking_service_label: "Service",
  booking_date_label: "Date",
  booking_time_label: "Heure",
  booking_another: "Réserver un autre rendez-vous",
  booking_failed: "Échec de la réservation. Veuillez réessayer.",
  booking_gdpr_text: "J'accepte que mes données personnelles (nom, e-mail, numéro de téléphone) soient traitées uniquement dans le but de gérer cette réservation, conformément aux réglementations applicables en matière de protection des données (LPD/RGPD). Mes données ne seront pas partagées avec des tiers.",
  booking_select_hint: "Sélectionnez un ou plusieurs services",
  booking_available: "Disponible",
  booking_unavailable: "Indisponible",
  booking_email_invalid: "Veuillez entrer une adresse e-mail valide",
};
